import { createContext } from "react";

export const VehicleContext = createContext({
  vehicle: {},
  onChange: () => {},
});
